import { createReducer, on } from '@ngrx/store';
import * as OmcRegistrationActions from './omc-registration.action';
import { BillDto } from '@modules/company-profile/responses/company-profile.response';
import {
  handleRequest,
  handleSuccess,
  handleFailure,
  handleClear,
} from '../../../../shared/ngrx-factory/factory.reducer';

const initialRequestState: OmcRegistrationActions.RequestState<any> = {
  loading: false,
  message: null,
  response: null,
  error: null,
};

export const initialOmcRegistrationState: OmcRegistrationActions.OmcRegistrationState = {
  omcRegistration: { ...initialRequestState },
  ewuraLicense: { ...initialRequestState },
  brelaLicense: { ...initialRequestState },
  importLicense: { ...initialRequestState },
  omcRegistrationProgress: { ...initialRequestState },
  submitDocuments: { ...initialRequestState },
  omcRegistrationSummary: { ...initialRequestState },
  omcSubmitApplication: { ...initialRequestState },
  omcSubmitBrelaLicense: { ...initialRequestState },
  omcViewAttachments: { ...initialRequestState },
  omcGenerateControlNumber: { ...initialRequestState },
  billByUuid: { ...initialRequestState },
  omcContacts: { ...initialRequestState },
};

export const omcRegistrationReducer = createReducer(
  initialOmcRegistrationState,

  // 1. OMC Registration
  on(OmcRegistrationActions.OmcRegActions.request, (state) =>
    handleRequest(state, 'omcRegistration'),
  ),
  on(OmcRegistrationActions.OmcRegActions.success, (state, { response }) =>
    handleSuccess(state, 'omcRegistration', response),
  ),
  on(OmcRegistrationActions.OmcRegActions.failure, (state, { error }) =>
    handleFailure(state, 'omcRegistration', error),
  ),

  // 2. EWURA License
  on(OmcRegistrationActions.EwuraLicenseActions.request, (state) =>
    handleRequest(state, 'ewuraLicense'),
  ),
  on(OmcRegistrationActions.EwuraLicenseActions.success, (state, { response }) =>
    handleSuccess(state, 'ewuraLicense', response),
  ),
  on(OmcRegistrationActions.EwuraLicenseActions.failure, (state, { error }) =>
    handleFailure(state, 'ewuraLicense', error),
  ),

  // 3. Registration Progress
  on(OmcRegistrationActions.OmcProgressActions.request, (state) =>
    handleRequest(state, 'omcRegistrationProgress'),
  ),
  on(OmcRegistrationActions.OmcProgressActions.success, (state, { response }) =>
    handleSuccess(state, 'omcRegistrationProgress', response),
  ),
  on(OmcRegistrationActions.OmcProgressActions.failure, (state, { error }) =>
    handleFailure(state, 'omcRegistrationProgress', error),
  ),

  // 4. Submit Documents
  on(OmcRegistrationActions.OmcDocumentActions.request, (state) =>
    handleRequest(state, 'submitDocuments'),
  ),
  on(OmcRegistrationActions.OmcDocumentActions.success, (state, { response }) =>
    handleSuccess(state, 'submitDocuments', response),
  ),
  on(OmcRegistrationActions.OmcDocumentActions.failure, (state, { error }) =>
    handleFailure(state, 'submitDocuments', error),
  ),

  // 5. Registration Summary
  on(OmcRegistrationActions.OmcSummaryActions.request, (state) =>
    handleRequest(state, 'omcRegistrationSummary'),
  ),
  on(OmcRegistrationActions.OmcSummaryActions.success, (state, { response }) =>
    handleSuccess(state, 'omcRegistrationSummary', response),
  ),
  on(OmcRegistrationActions.OmcSummaryActions.failure, (state, { error }) =>
    handleFailure(state, 'omcRegistrationSummary', error),
  ),

  // 6. Submit Application
  on(OmcRegistrationActions.OmcSubmitAppActions.request, (state) =>
    handleRequest(state, 'omcSubmitApplication'),
  ),
  on(OmcRegistrationActions.OmcSubmitAppActions.success, (state, { response }) =>
    handleSuccess(state, 'omcSubmitApplication', response),
  ),
  on(OmcRegistrationActions.OmcSubmitAppActions.failure, (state, { error }) =>
    handleFailure(state, 'omcSubmitApplication', error),
  ),

  // 7. View Attachments
  on(OmcRegistrationActions.OmcViewAttachmentActions.request, (state) =>
    handleRequest(state, 'omcViewAttachments'),
  ),
  on(OmcRegistrationActions.OmcViewAttachmentActions.success, (state, { response }) =>
    handleSuccess(state, 'omcViewAttachments', response),
  ),
  on(OmcRegistrationActions.OmcViewAttachmentActions.failure, (state, { error }) =>
    handleFailure(state, 'omcViewAttachments', error),
  ),

  // 8. Payment / Control Number
  on(OmcRegistrationActions.OmcPaymentActions.request, (state) =>
    handleRequest(state, 'omcGenerateControlNumber'),
  ),
  on(OmcRegistrationActions.OmcPaymentActions.success, (state, { response }) =>
    handleSuccess(state, 'omcGenerateControlNumber', response),
  ),
  on(OmcRegistrationActions.OmcPaymentActions.failure, (state, { error }) =>
    handleFailure(state, 'omcGenerateControlNumber', error),
  ),

  // 9. Bill By UUID
  on(OmcRegistrationActions.OmcBillActions.request, (state) => handleRequest(state, 'billByUuid')),
  on(OmcRegistrationActions.OmcBillActions.success, (state, { response }) =>
    handleSuccess(state, 'billByUuid', response),
  ),
  on(OmcRegistrationActions.OmcBillActions.failure, (state, { error }) =>
    handleFailure(state, 'billByUuid', error),
  ),

  // 10. BRELA License
  on(OmcRegistrationActions.BrelaLicenseActions.request, (state) =>
    handleRequest(state, 'brelaLicense'),
  ),
  on(OmcRegistrationActions.BrelaLicenseActions.success, (state, { response }) =>
    handleSuccess(state, 'brelaLicense', response),
  ),
  on(OmcRegistrationActions.BrelaLicenseActions.failure, (state, { error }) =>
    handleFailure(state, 'brelaLicense', error),
  ),

  // 11. BRELA License Submit
  on(OmcRegistrationActions.BrelaSubmitActions.request, (state) =>
    handleRequest(state, 'omcSubmitBrelaLicense'),
  ),
  on(OmcRegistrationActions.BrelaSubmitActions.success, (state, { response }) =>
    handleSuccess(state, 'omcSubmitBrelaLicense', response),
  ),
  on(OmcRegistrationActions.BrelaSubmitActions.failure, (state, { error }) =>
    handleFailure(state, 'omcSubmitBrelaLicense', error),
  ),

  // 12. Import License
  on(OmcRegistrationActions.ImportLicenseActions.request, (state) =>
    handleRequest(state, 'importLicense'),
  ),
  on(OmcRegistrationActions.ImportLicenseActions.success, (state, { response }) =>
    handleSuccess(state, 'importLicense', response),
  ),
  on(OmcRegistrationActions.ImportLicenseActions.failure, (state, { error }) =>
    handleFailure(state, 'importLicense', error),
  ),

  // ========================================
  // Custom Logic & Clears
  // ========================================
  on(OmcRegistrationActions.updateRegistrationSummaryBill, (state, { summary, billResponse }) => {
    const updatedBill = billResponse?.bills?.[0];
    const summaryResponse = state.omcRegistrationSummary.response;
    const currentSummary = summaryResponse?.data?.data;

    if (!updatedBill || !summaryResponse || !currentSummary) return state;

    const currentBills = currentSummary.bills ?? [];
    const hasMatchingBill = currentBills.some((bill: any) => bill.uuid === updatedBill.uuid);

    const mergedBills = hasMatchingBill
      ? currentBills.map((bill: any) =>
          bill.uuid === updatedBill.uuid ? { ...bill, ...updatedBill } : bill,
        )
      : billResponse.bills ?? currentBills;

    return {
      ...state,
      omcRegistrationSummary: {
        ...state.omcRegistrationSummary,
        response: {
          ...summaryResponse,
          data: {
            ...summaryResponse.data,
            data: {
              ...currentSummary,
              ...summary,
              registrationStatus: billResponse.registrationStatus,
              bills: mergedBills,
            },
          },
        },
      },
    };
  }),

  on(OmcRegistrationActions.clearOmcRegistrationResponse, (state) => ({
    ...state,
    omcRegistration: { ...initialOmcRegistrationState.omcRegistration },
  })),

  on(OmcRegistrationActions.clearOmcPaymentResponse, (state) => ({
    ...state,
    omcGenerateControlNumber: { ...initialOmcRegistrationState.omcGenerateControlNumber },
  })),

  on(OmcRegistrationActions.clearOmcViewAttachmentResponse, (state) =>
    handleClear(state, 'omcViewAttachments'),
  ),

  on(OmcRegistrationActions.clearOmcRegistrationContext, () => ({
    ...initialOmcRegistrationState,
  })),

  // OMC CONTRACT
  on(OmcRegistrationActions.OmcContractActions.request, (state) =>
    handleRequest(state, 'omcContacts'),
  ),
  on(OmcRegistrationActions.OmcContractActions.success, (state, { response }) =>
    handleSuccess(state, 'omcContacts', response),
  ),
  on(OmcRegistrationActions.OmcContractActions.failure, (state, { error }) =>
    handleFailure(state, 'omcContacts', error),
  ),
);
